import z from "zod";

const googleTranslateErrorTypeValues = [
  "MISSING_CREDENTIALS",
  "TRANSLATION_FAILED",
  "DETECTION_FAILED",
  "REQUEST_TIMEOUT",
] as const;

const googleTranslateErrorTypeSchema = z.enum(googleTranslateErrorTypeValues);
export const GoogleTranslateErrorType = googleTranslateErrorTypeSchema.enum;
export type GoogleTranslateErrorType = z.infer<typeof googleTranslateErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type GoogleTranslateErrors =
  | {
      errorType: typeof GoogleTranslateErrorType.MISSING_CREDENTIALS;
      data: undefined;
    }
  | {
      errorType: typeof GoogleTranslateErrorType.TRANSLATION_FAILED;
      data: {
        target: string;
        reason?: string;
      };
    }
  | {
      errorType: typeof GoogleTranslateErrorType.DETECTION_FAILED;
      data: {
        reason?: string;
      };
    }
  | {
      errorType: typeof GoogleTranslateErrorType.REQUEST_TIMEOUT;
      data: {
        operation: "detect" | "translate";
        timeoutMs: number;
      };
    };

export const googleTranslateErrorDetails: Record<GoogleTranslateErrorType, ErrorDetails> = {
  [GoogleTranslateErrorType.MISSING_CREDENTIALS]: {
    sentryDescription: "Google Translate service account credentials are missing",
  },
  [GoogleTranslateErrorType.TRANSLATION_FAILED]: {
    sentryDescription: "Google Translate text translation request failed",
  },
  [GoogleTranslateErrorType.DETECTION_FAILED]: {
    sentryDescription: "Google Translate language detection request failed",
  },
  [GoogleTranslateErrorType.REQUEST_TIMEOUT]: {
    sentryDescription: "Google Translate request timed out",
  },
};
